import routerOptions0 from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}